import React from 'react';

import StepWithOptions from 'containers/Quiz/StepWithOptions';

import { LOVERS_TRACKING, QUIZ_ROUTE } from '..';

const CHOICES = [
  {
    id: 1,
    text: 'components.LoversQuiz.Steps.Length.choices.1',
    tracking: 'quickie',
  },
  {
    id: 2,
    text: 'components.LoversQuiz.Steps.Length.choices.2',
    tracking: 'medium',
  },
  {
    id: 3,
    text: 'components.LoversQuiz.Steps.Length.choices.3',
    tracking: 'long',
  },
];

const section = {
  sectionName: 'length',
  choices: CHOICES,
};

const Length = () => {
  return (
    <StepWithOptions
      section={section}
      question={{ id: 'components.LoversQuiz.Steps.Length.question' }}
      tracking={{ name: LOVERS_TRACKING, url: `${QUIZ_ROUTE}/length` }}
    />
  );
};

export default Length;
